"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = exports.AnalyticsContext = void 0;
var react_1 = __importStar(require("react"));
var AnalyticsData_1 = require("../AnalyticsData/AnalyticsData");
var initialise_trackers_1 = require("../lib/initialise-trackers");
var AnalyticsContext = (0, react_1.createContext)(null);
exports.AnalyticsContext = AnalyticsContext;
function AnalyticsProvider(_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, trackers = _a.trackers, children = _a.children;
    var trackersReadyRef = (0, react_1.useRef)(false);
    var _c = (0, react_1.useState)(false), trackersReady = _c[0], setTrackersReady = _c[1];
    var eventsBufferRef = (0, react_1.useRef)([]);
    var initRef = (0, react_1.useRef)(true);
    // Required for the dispatch function
    trackersReadyRef.current = trackersReady;
    if (trackersReady && eventsBufferRef.current.length > 0) {
        eventsBufferRef.current.forEach(dispatch);
        eventsBufferRef.current = [];
    }
    if (initRef.current) {
        (0, initialise_trackers_1.initialiseTrackers)(trackers, setTrackersReady);
        initRef.current = false;
    }
    function dispatch(event) {
        // The dispatch function can be passed around into closures (e.g. setTimeout)
        // so we need to be able to check whether the trackers are actually ready by
        // evaluating a property on a "global" object instead, hence the requirement
        // for the ref.
        if (!trackersReadyRef.current) {
            eventsBufferRef.current.push(event);
            return;
        }
        trackers.forEach(function (tracker) {
            tracker.dispatch(event);
        });
    }
    return (react_1.default.createElement(AnalyticsContext.Provider, { value: {
            dispatch: dispatch,
        } },
        react_1.default.createElement(AnalyticsData_1.DataProvider, { data: data }, children)));
}
exports.AnalyticsProvider = AnalyticsProvider;
